export default __webpack_public_path__ + "static/media/hub_active_w.576840a5.svg";